import React from 'react'

export const KeyValueItem = ({ label, value }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ color: '#8c8c8c', marginBottom: 4, fontSize: 12 }}>
        {label}
      </div>
      <div style={{ color: '#000', fontSize: 14, minHeight: 22 }}>
        {value}
      </div>
    </div>
  )
}
